import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import { useEffect, useState } from "react";
import { API_URL } from "../../../constants/constants";
import { useNavigate } from "react-router-dom";


export default function data(data, pageType, callBack) {
  const [updatePlaceId, setUpdatePlaceId] = useState("");
  const navigate = useNavigate();

  return {
    columns: [
      { Header: "ID", accessor: "boardId", align: "center" },
      { Header: "제목", accessor: "title", align: "center" },
      { Header: "작성자", accessor: "writer", align: "center" },
      { Header: "작성일", accessor: "createAt", align: "center" },
      { Header: "수정일", accessor: "updateAt", align: "center" }
    ],

    rows: data.map((item) => ({
      boardId: (
        <MDTypography component="div" onClick={() => navigate(`/collins/brandArchive/editor?id=${item.id}`)}
                      variant="caption" style={{ cursor: "pointer" }}
                      color="text" fontWeight="medium">
          {item.id}
        </MDTypography>
      ),
      title: (
        <MDTypography component="div" onClick={() => navigate(`/collins/brandArchive/editor?id=${item.id}`)}
                      style={{ cursor: "pointer" }}
                      variant="caption" color="text"
                      fontWeight="bold">
          {item.title}
        </MDTypography>
      ),
      writer: (
        <MDTypography component="div" variant="caption" color="text" fontWeight="medium">
          {item.writer}
        </MDTypography>
      ),
      createAt: (
        <MDTypography component="div" variant="caption" color="text" fontWeight="medium">
          {item.register_date}
        </MDTypography>
      ),
      updateAt: (
        <MDTypography component="div" variant="caption" color="text" fontWeight="medium">
          {item.update_date}
        </MDTypography>
      )
    }))
  };
};
